import { z } from 'zod';

export const MdmDateRangeSchema = z.object({
  dateFrom: z.string(),
  dateTo: z.string(),
});

export type MdmDateRangeValue = z.infer<typeof MdmDateRangeSchema>;

export const MdmAttributeValueSchema = z.object({
  value: z
    .union([z.string(), z.number(), z.boolean(), MdmDateRangeSchema])
    .nullable(),
  isReadOnly: z.boolean().default(false),
});
